import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { Denuncia } from "../denuncia/denuncia";
import { DenunciasService } from "./denuncias.service";

import { Status } from "../denuncia/status";

import { AuthAndACLService } from "../auth_and_acl/authAndACL.service";
import { Usuario } from "../usuario/usuario";

@Component({
  selector: "app-denuncias",
  templateUrl: "./denuncias.component.html",
  styleUrls: ["./denuncias.component.css"],
  providers: [DenunciasService]
})
export class DenunciasComponent implements OnInit {
  public usuario: Usuario;

  denuncias: Denuncia[];

  denuncia: Denuncia;

  statuss: Status[];
  status: Status;

  imgVerIncidente = "../../assets/img/viewicon.png";

  imgAdEntrevista = '../../assets/img/plusicon.png';

  imgRemIncidente = '../../assets/img/removeicon.png';

  imgListEntrevista = '../../assets/img/listicon.png';

  imgResumoCaso = '../../assets/img/clipboardicon.png';

  imgVerResumo = '../../assets/img/searchicon.png';

  imgIncluirEncam = '../../assets/img/arrowicon.png';

  imgVerEncaminhamento = '../../assets/img/eyeicon.png';

  imgIncluirFinaliz = '../../assets/img/endicon.gif';

  imgReabrirEntrevista = '../../assets/img/backicon.png';

  imgAgEntrevista = '../../assets/img/scheduleicon.png';

  imgVerAnaliseCaso = '../../assets/img/abouticon.png';

  linkPert: boolean;

  linkResp: boolean;

  linkAddEnt: boolean;

  linkAddRes: boolean;

  linkAddEncam: boolean;

  linkAgendEnt: boolean;

  linkReabrirEntrev: boolean;

  linkEncamPsic: boolean;

  linkFinalizIncid: boolean;

  linkVerAnaliseCaso: boolean;

  constructor(
    private denunciaService: DenunciasService,
    public authAndACL: AuthAndACLService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.denuncia = new Denuncia();
    this.status = new Status();
  }

  getDenunciasPorStatus(): void {
    //console.log('status:'+this.status['id']);
    let idStatus = this.status['id'];
    this.denunciaService.getDenunciasPorStatus(idStatus.toString()).then(denuncia => {
      this.denuncias = denuncia;
    });

  }

  getStatusDenuncias(): void {
    let status_ocultos = {"POST":{"ocultos": ["nao-pertinente", "finalizado-sindicancia", "finalizado-outros", "finalizado-nenhum"]}};
    this.denunciaService.getStatus(status_ocultos).then(status => {
      this.statuss = status['dados'];
    });
    //console.log(status['dados']);
  }

  getDenuncias(): void {
    //console.log('obtendo denuncias..');
    this.denunciaService.getDenuncias().then(denuncia => {
      //console.log(denuncia);
      this.denuncias = denuncia;
    });
  }

  reopenEntrevista(): void {
    this.denunciaService
      .reopenEntrevista(this.denuncia)
      .then(() => this.goBack());
  }

  goBack(): void {
    this.router.navigate(['/denuncias']);
  }

  getAcesso(): void {

    if (
      this.authAndACL.canAccess([
        'Responsavel Geral',
        'Responsavel Acolhimento'
      ])
    ) {
      this.linkVerAnaliseCaso = true; // link para ver a analise do caso
    }


    // selecao de responsaveis, marcar nao pertinencia, fazer encaminhamento e outros somente para coordenadores
    if (
      this.authAndACL.canAccess([
        'Coordenador Geral',
        'Coordenador Acolhimento'
      ])
    ) {
      this.linkResp = true; // link para selecionar responsaveis
      this.linkPert = true; // link para registrar o incidente como nao pertinente
      this.linkAddEncam = true; // link para adicionar encaminhamento
      this.linkAgendEnt = true; // link para agendar entrevista
      this.linkAddEnt = true; // link para adicionar entrevista
      this.linkAddRes = true; // link para adicionar resumo do caso
      this.linkReabrirEntrev = true; // link para reabrir entrevistas
      this.linkEncamPsic = true; // link para encaminhamento psicologico
      this.linkFinalizIncid = true; // link para finalizar incidente

    } else {
      // responsaveis nao podem selecionar responsaveis para a entrevista nem setar como nao pertinente nem encaminhar incidente (somente o psicologico) e nem reabrir entrevistas
      this.linkResp = false;
      this.linkPert = false;
      this.linkAddEncam = false;
      this.linkReabrirEntrev = false;
      this.linkFinalizIncid = false;

      if (
        this.authAndACL.canAccess([
          'Responsavel Geral',
          'Responsavel Acolhimento'
        ])
      ) {
        this.linkAgendEnt = true; // link para agendar entrevista
        this.linkAddEnt = true; // link para adicionar entrevista
        this.linkAddRes = true; // link para adicionar resumo do caso
        this.linkEncamPsic = true; // link para encaminhamento psicologico

      } else {
        // admin
        this.linkAgendEnt = false;
        this.linkAddEnt = false;
        this.linkAddRes = false;
        this.linkEncamPsic = false;
      }
    }

  }

  ngOnInit() {
    if (this.authAndACL.logado()) {
      this.usuario = new Usuario();
      this.usuario = this.authAndACL.getUserData(); // obtem dados do usuario logado
      //console.log('USERID = ' + this.usuario.nome);
      this.getAcesso();
    }

    this.route.params.forEach((params: Params) => {
      let id = params['id']; // id do incidente
      if (id === undefined) {
        this.getDenuncias();
        this.getStatusDenuncias();
      } else {
        this.denuncia.id = id;
        this.reopenEntrevista();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/denuncias.component.ts